var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerImmunefi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 51,
    viewBox: "0 0 223 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_5745)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5888 21.7578L27.9502 37.395L43.1476 21.9248L55.6082 34.609L41.1306 49.3465L37.4061 45.6563L48.2585 34.609L43.1476 29.4063L27.9502 44.8765L12.5888 29.2394L7.54001 34.3788L18.5575 45.594L14.833 49.2842L0.19043 34.3788L12.5888 21.7578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2099 29.2409L27.8485 13.6039L12.6512 29.074L0.190552 16.3897L14.6681 1.65234L18.3925 5.34259L7.54012 16.3897L12.6512 21.5926L27.8485 6.12235L43.2099 21.7595L48.2587 16.62L37.2412 5.4048L40.9656 1.71455L55.6082 16.62L43.2099 29.2409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5554 48.9809V39.1289H30.5717V48.9809H25.5554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5554 11.8715V2.01953H30.5717V11.8715H25.5554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5113 13.2812H67.5127V38.4486H72.5113V13.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8663 19.9258C95.5941 19.9258 93.427 20.9046 92.3434 23.0369C91.2248 20.9046 89.1276 19.9258 86.6807 19.9258C84.4785 19.9258 82.8008 20.7647 81.9269 22.2678L81.4026 20.2754H76.8584V38.4519H81.7521V28.2799C81.7521 25.5885 83.1503 24.2952 85.2126 24.2952C87.1701 24.2952 88.4984 25.5186 88.4984 28.4897V38.4519H93.2172V28.3848C93.2871 25.5535 94.7552 24.2952 96.6777 24.2952C98.6702 24.2952 99.9635 25.5186 99.9635 28.2451V38.4867H104.892V27.2664C104.892 22.2328 101.501 19.9258 97.8663 19.9258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.783 19.9258C127.511 19.9258 125.344 20.9046 124.261 23.0369C123.142 20.9046 121.044 19.9258 118.598 19.9258C116.396 19.9258 114.718 20.7647 113.844 22.2678L113.319 20.2754H108.775V38.4519H113.669V28.2799C113.669 25.5885 115.067 24.2952 117.13 24.2952C119.087 24.2952 120.415 25.5186 120.415 28.4897V38.4519H125.134V28.3848C125.203 25.5535 126.673 24.2952 128.595 24.2952C130.587 24.2952 131.881 25.5186 131.881 28.2451V38.4867H136.809V27.2664C136.809 22.2328 133.419 19.9258 129.783 19.9258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.612 20.2734V30.2355C152.612 32.927 151.353 34.5349 148.941 34.5699C146.634 34.6397 145.166 33.2765 145.166 30.4452V20.2734H140.518V31.0744C140.518 35.7233 143.208 38.7994 147.858 38.7994C150.025 38.7994 151.597 37.8206 152.541 36.4574L152.787 38.4499H157.26V20.2734H152.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.621 19.9258C168.895 19.9258 167.077 20.9395 166.133 22.4426L165.854 20.2754H161.31V38.4519H166.204V28.8392C166.204 25.903 167.601 24.1204 170.188 24.1204C172.566 24.1204 173.999 25.6584 173.999 28.6645V38.4519H178.927V27.6508C178.927 23.0019 176.27 19.9258 171.621 19.9258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.328 29.084C200.328 23.5261 196.727 19.9258 191.309 19.9258C185.891 19.9258 182.257 23.7009 182.257 29.3636C182.257 35.0613 185.891 38.8363 191.345 38.8363C195.924 38.8363 199.384 36.2846 200.188 32.5095H195.259C194.701 34.0824 193.268 34.8864 191.484 34.8864C189.143 34.8864 187.254 33.3834 187.185 30.6919H200.328V29.084ZM191.309 23.7359C193.441 23.7359 195.225 24.9594 195.434 27.476H187.22C187.429 24.9594 189.213 23.7359 191.309 23.7359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.239 20.2736V24.538H205.036V38.45H209.964V24.538H214.124V20.2736H209.964V18.421C209.964 17.1276 210.313 16.1489 212.306 16.1489H214.124V12.1641H211.223C206.643 12.1641 205.036 14.4012 205.036 17.9316V20.2736H202.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.355 17.4772H222.319L222.389 12.1641H217.426L217.355 17.4772ZM217.426 38.45H222.319V20.2736H217.426V38.45Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_5745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222.619,
    height: 50,
    fill: "white",
    transform: "translate(0.19043 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerImmunefi);
export default __webpack_public_path__ + "static/media/partner-immunefi.76854c4befae3ffdd3e110fd12ccfbf1.svg";
export { ForwardRef as ReactComponent };